import { Link } from 'react-router-dom';
import { ARTICLE_CATEGORIES, articlePath } from '../constants/articles';
import {
  ADDRESS,
  BRAND_NAME,
  COMPANY_NAME,
  SITE_DOMAIN,
  SUPPORT_PHONE_LABEL,
  SUPPORT_PHONE_TEL,
} from '../constants/site';

const POLICY_LINKS = [
  { label: 'About Us', to: '/about-us' },
  { label: 'Contact Us', to: '/contact-us' },
  { label: 'Privacy Policy', to: '/privacy-policy' },
  { label: 'Terms & Conditions', to: '/terms-and-conditions' },
  { label: 'Refund Policy', to: '/refund-policy' },
  { label: 'Disclaimer', to: '/disclaimer' },
];

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="site-footer">
      <div className="footer-widgets">
        <div className="footer-widgets__inner">
          {ARTICLE_CATEGORIES.map((cat) => (
            <div key={cat.key} className="footer-col">
              <h2 className="footer-col__title">
                <Link to={cat.hub}>{cat.label}</Link>
              </h2>
              <ul>
                {cat.articles.map((article) => (
                  <li key={article.slug}>
                    <Link to={articlePath(article.slug)}>&gt; {article.title}</Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="footer-widgets__inner footer-meta">
          <p>
            <strong>{COMPANY_NAME}</strong> · {ADDRESS} · Phone:{' '}
            <a href={SUPPORT_PHONE_TEL}>{SUPPORT_PHONE_LABEL}</a>
          </p>
          <ul className="footer-meta__links">
            {POLICY_LINKS.map((item) => (
              <li key={item.to}>
                <Link to={item.to}>{item.label}</Link>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div className="site-info">
        <div className="site-info__inner">
          <p className="site-info__copy">
            © {year} {BRAND_NAME}
          </p>
          <p>
            <Link to="/">{SITE_DOMAIN}</Link> provides independent, fee-based technical help for
            people who use Family Tree Maker. We operate on our own and have no partnership with
            Software MacKiev, Ancestry, FamilySearch, or any other brand named here. Their
            trademarks belong to them and are mentioned only to describe the products we support.
          </p>
        </div>
      </div>
    </footer>
  );
}
